import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
const useStyles = makeStyles((theme) => ({
	paper: {
		width: "100%"
	},
	clientName: {
		paddingLeft: theme.spacing(0.5)
	},
	clientAutomaticMessages: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[200]),
		textAlign: "center",
		borderRadius: 18,
		padding: 5,
		width: 70,
		heigth: 32,
		color: colors.gray[700]
	},
	clientNickname: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		maxWidth: "150px"
	},
	wabaCommunicationPermissionDot: {
		width: 12,
		height: 12,
		borderRadius: "100%",
		display: "block"
	},
	wabaCommunicationPermissionDotActive: {
		backgroundColor: colors.green[700]
	},
	wabaCommunicationPermissionDotExpiring: {
		backgroundColor: colors.yellow[600]
	},
	wabaCommunicationPermissionDotPaused: {
		backgroundColor: colors.gray[300]
	},
	metaFreeEntryPointWindowBadge: {
		backgroundColor: colors.purple[100],
		color: colors.purple[700],
		border: `1px solid ${colors.purple[200]}`,
		borderRadius: 12,
		padding: "2px 8px",
		fontSize: 11,
		fontWeight: 700,
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		marginLeft: theme.spacing(0.5)
	},
	metaFreeEntryPointWindowBadgeExpiring: {
		opacity: 0.6
	},
	metaFreeEntryPointWindowBadgeIcon: {
		width: 14,
		height: 14,
		color: colors.purple[700],
		display: "block"
	},
	communicationPermissionLegendContainer: {
		marginTop: 8
	},
	communicationPermissionLegendLabel: {
		fontWeight: 600
	},
	automaticMessagesHeaderCell: {
		textAlign: "center"
	},
	actionsHeaderCell: {
		padding: 0,
		width: 256
	},
	clientNameMinWidth: {
		minWidth: 0
	},
	clientNicknameOverflow: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	lidContactWarningItem: {
		margin: "0 4px"
	},
	clientNameOverflowContainer: {
		minWidth: 0,
		overflow: "hidden"
	},
	clientNameSecondaryText: {
		color: colors.gray[500],
		fontWeight: 400,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	metaFreeEntryPointWindowBadgeItem: {
		flexShrink: 0
	},
	phoneNumberText: {
		fontSize: 16
	},
	tagChip: {
		color: colors.gray[50],
		height: 12,
		width: 64
	},
	automaticMessagesCellContainer: {
		display: "flex",
		justifyContent: "center"
	},
	popoverListItemIcon: {
		width: 22,
		height: 22
	}
}))

export default useStyles
